import React from 'react'

export default function Canteen() {
    return (
        <div>Canteen</div>
    )
}
